import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button } from '@material-ui/core';
import ForwardIcon from '@material-ui/icons/Forward';
import LockIcon from '@material-ui/icons/Lock';

const Root = styled(Box)({
    width: '100%',
    maxHeight: '650px',
    overflowX: 'auto',
    '& .wapper': {
        padding: '10px 15px',
        cursor: 'pointer',
        '& .icon': {
            visibility: 'hidden',
        },
        '& .lockIcon': {
            width: '15px',
            marginRight: '5px',
        },
    },
    '& .wapper:hover': {
        backgroundColor: '#009CEE',
        color: '#fff',
        '& .icon': {
            visibility: 'visible',
            color: '#fff',
        },
        '& .lockIcon': {
            width: '15px',
            marginRight: '5px',
            color: '#fff',
        },
    },
    '& .wapperSelect': {
        padding: '10px 15px',
        cursor: 'pointer',
        backgroundColor: '#009CEE',
        color: '#fff',
        '& .icon': {
            visibility: 'visible',
            color: '#fff',
        },
        '& .lockIcon': {
            width: '15px',
            marginRight: '5px',
            color: '#fff',
        },
    },
})

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
class SideMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnName: this.btnName(this.props.state)
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    render() {
        const { menuData, menuIndex, lockStep } = this.props;
        const lockView = (index) => {
            if (index >= lockStep) {
                return <LockIcon className="lockIcon" />
            }
        }
        return (
            <Root>
                {menuData.map((row, index) => (
                    <div key={index} className={menuIndex === index ? "wapperSelect h" : "wapper h"} onClick={e => this.handleClick(e, index)}>
                        <div className='f'>
                            <div className="h">
                                {lockView(index)}
                                {row}
                            </div>
                        </div>
                        <ForwardIcon className='icon'></ForwardIcon>
                    </div>
                ))}
            </Root>
        )
    }
    componentDidMount() {
        // doLockStep
    }
    handleCancel() {
        this.props.handleCancel();
    }
    //可点击
    // lockStep无值
    // lockStep有值并且大于0
    //不可点击
    // lockStep有值并且小于0
    // lockStep有值并且index小于lockStep
    handleClick(e, index) {
        const { isLock, lockStep } = this.props;
        if (!isLock) {
            if (lockStep === undefined) {
                this.props.handleMenuIndex(index);
            } else {
                if (lockStep > 0) {
                    if (index < lockStep) {
                        this.props.handleMenuIndex(index);
                    }
                }
            }
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default SideMenu;